import BatIcon from "@/components/logos/BatIcon";
import {
  brandConfig,
  buildBrandTitle,
} from "@nitro-ape/shared/lib/brand-config";
import { getEnv } from "@/lib/env";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/maintenance/")({
  head: () => ({
    meta: [{ title: buildBrandTitle(getEnv, "Maintenance") }],
  }),
  component: MaintenancePage,
});

function MaintenancePage() {
  return (
    <div className="relative flex min-h-screen w-screen items-center justify-center bg-[#0B0B11]">
      <img
        alt="bg-visual"
        src={brandConfig(getEnv).loginBackgroundImagePath}
        className="absolute inset-0 z-0 hidden h-full w-full object-left md:block"
      />
      <div className="bg-card z-10 mx-3 flex w-full max-w-[530px] flex-col items-center rounded-[25px] px-5 pb-[52px] pt-[44px]">
        <div className="bg-dark-green mb-3 flex h-[60px] w-[60px] items-center justify-center rounded-full p-3 md:h-[72px] md:w-[72px]">
          <BatIcon />
        </div>
        <p className="mb-4 text-3xl">Maintenance</p>
        <p className="text-gray-p text-center text-base">
          We&apos;re currently performing maintenance on the platform. We will
          be operational soon
        </p>
      </div>
    </div>
  );
}
